import { InputModule } from './input/input.module';
import { NgModule } from '@angular/core';
import { DialogComponent } from './dialog/dialog.component';
import { ButtonModule } from './button/button.module';
import { ConfirmDeleteDialogComponent } from './confirm-delete-dialog/confirm-delete-dialog.component';
import { PreviewPdfComponent } from './preview-pdf/preview-pdf.component';
import { MaterialModule } from '../../shared/material.module';
import { CommonModule } from '@angular/common';
import { NotiComponent } from './noti/noti.component';
import { RouterModule } from '@angular/router';
@NgModule({
  imports: [
    ButtonModule,
    MaterialModule,
    RouterModule,
    CommonModule
  ],
  declarations: [
    DialogComponent,
    ConfirmDeleteDialogComponent,
    PreviewPdfComponent,
    NotiComponent,
  ],
  exports: [
    ButtonModule,
    DialogComponent,
    InputModule,
    ConfirmDeleteDialogComponent,
    NotiComponent,
  ],
  entryComponents: [
    ConfirmDeleteDialogComponent,
    PreviewPdfComponent,
  ],
})
export class ComponentsModule { }
